// extracted by mini-css-extract-plugin
export default {"form":"SettingsAccounts_form__4LSyn"};